{
  "version": 1,
  "asset_id": "db1867bd-8032-41d7-817c-66874f5365f1",
  "project_id": "7ac59465-c0f2-4b6e-9949-d18c7a8fae04",
  "url": "/__l5e/assets-v1/db1867bd-8032-41d7-817c-66874f5365f1/cover-800.jpg",
  "r2_key": "a/v1/7ac59465-c0f2-4b6e-9949-d18c7a8fae04/db1867bd-8032-41d7-817c-66874f5365f1/cover-800.jpg",
  "original_filename": "cover-800.jpg",
  "size": 64779,
  "content_type": "image/jpeg",
  "created_at": "2026-06-25T01:16:08Z"
}
